export class MunicipalityModel {
  id: string;
  name: string;
  language: string;
  city: string;
  country: string;
  buildings: number;

  constructor() {
    this.id = '';
    this.name = '';
    this.city = '';
    this.language = '';
    this.country = 'Republic of Macedonia';
  }
}
